export var getTZC = function (offset) {
    var negative = offset < 0;
    if (negative) {
        offset *= -1;
    }
    offset /= 60000;
    var hours = (offset / 60) | 0;
    var minutes = (offset % 60) | 0;
    return [offset, negative, hours, minutes];
};
//# sourceMappingURL=zoneutil.js.map